// MIT License - Copyright (c) 2026 Doug McNall

/**
 * Mass Effect Universe - Warp Gates Configuration
 * 
 * Mass Relays connecting to other universes
 */

export const warpGates = [
  {
    id: 'gate-masseffect-milkyway',
    name: 'Sol Relay',
    type: 'warpgate',
    distance: 25,
    fromUniverse: 'masseffect',
    destinationUniverse: 'milkyway',
    fromSystem: 900,
    toSystem: 0,
    destinationGate: 'gate_milkyway_to_masseffect',
    energyCost: 50,
    fuelRequired: 5,
    threat: 'SAFE',
    resources: 'MASS RELAY',
    services: [],
    primaryColor: '#00d4ff',
    secondaryColor: '#00ffff',
    hasRings: true,
    discovered: false,
    description: 'Mass relay to Sol system. Ancient Prothean construction.'
  },
  {
    id: 'gate-masseffect-halo',
    name: 'Charon Relay',
    type: 'warpgate',
    distance: 15,
    fromUniverse: 'masseffect',
    destinationUniverse: 'halo',
    fromSystem: 900,
    toSystem: 1800,
    destinationGate: 'gate-halo-masseffect',
    energyCost: 50,
    fuelRequired: 5,
    threat: 'MODERATE',
    resources: 'MASS RELAY',
    services: [],
    primaryColor: '#00d4ff',
    secondaryColor: '#0088ff',
    hasRings: true,
    discovered: true,
    description: 'Mass relay connecting to UNSC space. Element Zero signatures detected.'
  },
  {
    id: 'gate-masseffect-startrek',
    name: 'Serpent Nebula Relay',
    type: 'warpgate',
    distance: 20,
    fromUniverse: 'masseffect',
    destinationUniverse: 'startrek',
    fromSystem: 900,
    toSystem: 1900,
    destinationGate: 'gate-startrek-masseffect',
    energyCost: 50,
    fuelRequired: 5,
    threat: 'SAFE',
    resources: 'MASS RELAY',
    services: [],
    primaryColor: '#00d4ff',
    secondaryColor: '#ff00ff',
    hasRings: true,
    discovered: true,
    description: 'Mass relay to Federation space. Subspace and eezo fields interact strangely.'
  },
  {
    id: 'gate-masseffect-starwars',
    name: 'Omega-4 Relay',
    type: 'warpgate',
    distance: 30,
    fromUniverse: 'masseffect',
    destinationUniverse: 'starwars',
    fromSystem: 900,
    toSystem: 800,
    destinationGate: 'gate-starwars-masseffect',
    energyCost: 50,
    fuelRequired: 5,
    threat: 'MODERATE',
    resources: 'MASS RELAY',
    services: [],
    primaryColor: '#00d4ff',
    secondaryColor: '#FFE81F',
    hasRings: true,
    discovered: false,
    description: 'Mass relay to a galaxy far, far away. Hyperspace and mass effect fields converge.'
  },
  {
    id: 'gate-masseffect-doctorwho',
    name: 'Conduit Relay',
    type: 'warpgate',
    distance: 35,
    fromUniverse: 'masseffect',
    destinationUniverse: 'doctorwho',
    fromSystem: 900,
    toSystem: 1000,
    destinationGate: 'gate-doctorwho-masseffect',
    energyCost: 50,
    fuelRequired: 5,
    threat: 'TEMPORAL',
    resources: 'MASS RELAY',
    services: [],
    primaryColor: '#00d4ff',
    secondaryColor: '#003B6F',
    hasRings: true,
    discovered: false,
    description: 'Mass relay with temporal anomalies. Time vortex energy detected. Wibbly-wobbly.'
  },
  {
    id: 'gate-masseffect-warhammer40k',
    name: 'Mu Relay',
    type: 'warpgate',
    distance: 40,
    fromUniverse: 'masseffect',
    destinationUniverse: 'warhammer40k',
    fromSystem: 900,
    toSystem: 1100,
    destinationGate: 'gate-warhammer40k-masseffect',
    energyCost: 50,
    fuelRequired: 5,
    threat: 'EXTREME',
    resources: 'MASS RELAY',
    services: [],
    primaryColor: '#00d4ff',
    secondaryColor: '#ff0000',
    hasRings: true,
    discovered: false,
    description: 'Mass relay corrupted by Warp energy. Immaterium breach detected. The Emperor protects.'
  }
];

export const warpGatePositions = {
  'gate-masseffect-milkyway': { x: 48, y: 58, z: 3 },
  'gate-masseffect-halo': { x: 62, y: 48, z: 5 },
  'gate-masseffect-startrek': { x: 38, y: 52, z: -4 },
  'gate-masseffect-starwars': { x: 55, y: 42, z: 6 },
  'gate-masseffect-doctorwho': { x: 32, y: 60, z: -5 },
  'gate-masseffect-warhammer40k': { x: 65, y: 55, z: 8 }
};
